module.exports = __webpack_public_path__ + "img/LCATree3.0aa8fb2c.jpg";